module.exports = __webpack_public_path__ + "static/lilianafolta-cover-35ed76c4744c79b9ef336df0ebb53ce0.jpg";